import React, { useState } from 'react'
import {
    AddToWatchList,
    assignCard,
    RemoveToWatchList,
    updateCard,
  } from "../../../../../../sevices/apiCards";
import useMutate from '../../../../../../hooks/useMutate';
import { useQueryClient } from '@tanstack/react-query';
export const useSidebarMutations = (cardId, boardId, milestone) => {   
  const [dueDate, setDueDate] = useState(false);
  const [showEpic, setShowEpic] = useState(false);
  const queryClient = useQueryClient();

  const invalidateCardQueries = () => {


    queryClient.invalidateQueries({
      queryKey: [`card`, Number(cardId)],
    });
    
    queryClient.invalidateQueries({
      queryKey: [`card`, String(cardId)],
    });
    
    queryClient.invalidateQueries({
      queryKey: [`cards`, boardId],
    });
    queryClient.invalidateQueries({
      queryKey: [`lebels`, boardId],
    });

    if (milestone) {
      queryClient.invalidateQueries({
        queryKey: ["milestone_history", milestone],
      });
      queryClient.invalidateQueries({
        queryKey: ["epic_id", milestone],
      });
    }


    queryClient.invalidateQueries({
      queryKey: [`history`, Number(cardId)],
    });

    queryClient.invalidateQueries({
      queryKey: [`mineCards`],
    });queryClient.invalidateQueries({
      queryKey: [`userCards`],
    });queryClient.invalidateQueries({
      queryKey: [`assignedCards`],
    });
    queryClient.invalidateQueries({
      queryKey: [`watching`],
    });
  };

  const { mutate: updateCardmutate } = useMutate(
    updateCard, 
    ['mineCards', 'watching'],
    ()=>{},
    () => {
      invalidateCardQueries();
      setDueDate(false);
      setShowEpic(false);
    },
    ()=>{}
  );

  const { mutate: assignCardMutate } = useMutate(
    assignCard,
    ['boards', 'mineCards', 'useCards'],
    ()=>{},
    () => {
      queryClient.invalidateQueries({
        queryKey: [`boards`],
      });
      
      invalidateCardQueries();
      setDueDate(false);
      setShowEpic(false);
    },
    ()=>{}
  );

  const { mutate } = useMutate(AddToWatchList, [], 
    ()=>{},
    () => {
      queryClient.invalidateQueries({
        queryKey: [`card`, cardId],
      });
      // queryClient.invalidateQueries({
      //   queryKey: [`card`, String(cardId)],
      // });
      queryClient.invalidateQueries({
        queryKey: [`watching`],
      });
      queryClient.invalidateQueries({
        queryKey: [`cards`, boardId],
      });
    },
    ()=>{}
  );
  
  const { mutate: removeWatchListMutate } = useMutate(
    RemoveToWatchList,
    [],
    ()=>{},
    () => {
      queryClient.invalidateQueries({
        queryKey: [`card`, cardId],
      });
      queryClient.invalidateQueries({
        queryKey: [`watching`],
      });
      queryClient.invalidateQueries({
        queryKey: [`cards`, boardId],
      });
    },
    ()=>{}
  );

  return {
    updateCardmutate,
    assignCardMutate,
    mutate,
    removeWatchListMutate,
    setDueDate,
    setShowEpic,
    dueDate,
    showEpic
  };
}
